<script setup lang="ts">
import { useMagicKeys, whenever } from '@vueuse/core'
import { toggleBodyClass } from './utils/helpers'

import { useStorage } from '@vueuse/core'

// bind object
const state = useStorage('debug-state', { debugMode: true })

const { ctrl_d } = useMagicKeys({
  passive: false,
  onEventFired(e) {
    if (e.ctrlKey && e.key === 'd' && e.type === 'keydown') e.preventDefault()
  },
})

whenever(ctrl_d, () => {
  // console.log('Ctrl+D have been pressed')
  toggleBodyClass('debug-mode')
  state.value.debugMode = !state.value.debugMode
})

whenever(
  state,
  (state) => {
    if (state.debugMode) toggleBodyClass('debug-mode')
  },
)
</script>

<template></template>

<style>
</style>
